module.exports = __webpack_public_path__ + "static/media/logo.e806b13f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo.png
// module id = 411
// module chunks = 0